import { Button, Divider, List, Skeleton, Tabs } from 'antd';
import { useNotification } from 'features/notification';
import { NotificationTitle } from 'hrm-common/extensions/enums/personel';
import countBy from 'lodash/countBy';
import filter from 'lodash/filter';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';

import styled from 'styled-components';
import {
  allNotifications,
  getNotifications,
  getNotificationsLineManager,
  readNotifications,
} from 'app/commonRedux/notificationSlice';
import { getUser } from 'utils/auth';
import RowNotifications from './RowNotifications';
import { useAppDispatch, useAppSelector } from 'app/hooks';

const TAB_TIMESHEET = 'Timesheet';
const UNREAD_STATUS = 'unread';

interface Props {
  onToggle: (value: boolean) => void;
  onItemClicked?: () => void;
  onChangeFilters: (value: any) => void;
  onChangeFiltersLineManager: (value: any) => void;
}
const { TabPane } = Tabs;

const ListNotification = (props: Props) => {
  const notifications = useAppSelector((state) => state.notification.notifications);
  const totalNoti = useAppSelector((state) => state.notification.totalNoti);
  const notificationsLineManagers = useAppSelector(
    (state) => state.notification.notificationsLineManagers,
  );
  const totalNotiLineManager = useAppSelector((state) => state.notification.totalNotiLineManager);
  const unreadNotiLineManager = useAppSelector((state) => state.notification.unreadNotiLineManager);
  const unreadNotiTotal = useAppSelector((state) => state.notification.badgeNumber);

  const { t } = useTranslation(['header']);
  const dispatch = useAppDispatch();
  const [, setCurrentTab] = useState(TAB_TIMESHEET);
  const [isShowOnlyReaded, setIsShowOnlyReaded] = useState(false);
  const [currentDataTimesheet, setCurrentDataTimesheet] = useState([]);
  const [currentPageTimesheet, setCurrentPageTimesheet] = useState(1);
  const [currentDataWatchingList, setCurrentDataWatchingList] = useState([]);
  const [currentPageWatchingList, setCurrentPageWatchingList] = useState(1);
  const [data, setData] = useState([]);
  const [dataWatching, setDataWatching] = useState([]);

  const notification = useNotification();
  const [filterNotiChange, setFilterNotiChange] = useState({
    offset: 1,
    limit: 10,
    type: [],
  });
  const [filterNotiChangeLineManager, setFilterNotiChangeLineManager] = useState({
    offset: 1,
    limit: 10,
    type: [NotificationTitle.WATCHING_LIST, NotificationTitle.CONTRACT],
  });

  useEffect(() => {
    loadDataByStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications, isShowOnlyReaded]);

  useEffect(() => {
    loadDataLineManagerByStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShowOnlyReaded, notificationsLineManagers]);

  const removeDuplicates = (arr: Array<string>) => {
    const uniqueArray = arr.filter((value, index) => {
      const _value = JSON.stringify(value);
      return (
        index ===
        arr.findIndex((obj) => {
          return JSON.stringify(obj) === _value;
        })
      );
    });

    const counts = countBy(uniqueArray, 'id');
    const arrDuplicate = filter(uniqueArray, (x) => counts[x.id] > 1);

    if (arrDuplicate.length > 0) {
      const index = uniqueArray.findIndex((x) => x.id === arrDuplicate[0].id);
      uniqueArray.splice(index, 1, arrDuplicate[1]);
    }
    return uniqueArray;
  };

  const callback = (key: any) => {
    setIsShowOnlyReaded(false);
    setCurrentTab(key);
  };

  const onItemClicked = (item: any) => {
    notification.navigateNotificationItem(item);
  };

  const markItemAsRead = async (item: any, visible: boolean) => {
    if (item && visible && item.status === 'unread') {
      await dispatch(readNotifications({ userId: getUser().id, notiId: item.id }));
      dispatch(
        getNotifications({
          userId: getUser().id,
          limit: filterNotiChange.limit,
          offset: filterNotiChange.offset,
          titles: filterNotiChange.type,
        }),
      );
      dispatch(
        getNotificationsLineManager({
          userId: getUser().id,
          limit: filterNotiChangeLineManager.limit,
          offset: filterNotiChangeLineManager.offset,
          titles: filterNotiChangeLineManager.type,
        }),
      );
    }
  };

  const loadDataByStatus = () => {
    if (isShowOnlyReaded) {
      let newData = notifications.filter((i: any) => i?.status === UNREAD_STATUS);

      setData(removeDuplicates(newData));
    } else {
      setData((data: any) => removeDuplicates([...data, ...notifications]));
    }
  };

  const loadDataLineManagerByStatus = () => {
    if (isShowOnlyReaded) {
      let newDataLineManager = notificationsLineManagers.filter(
        (i: any) => i?.status === UNREAD_STATUS,
      );

      setDataWatching(removeDuplicates(newDataLineManager));
    } else {
      setDataWatching((dataWatching: any) =>
        removeDuplicates([...dataWatching, ...notificationsLineManagers]),
      );
    }
  };

  useEffect(() => {
    setCurrentDataWatchingList(removeDuplicates(dataWatching));
  }, [currentPageWatchingList, dataWatching]);

  useEffect(() => {
    setCurrentDataTimesheet(removeDuplicates(data));
  }, [data, currentPageTimesheet]);

  const loadMoreTimesheet = () => {
    setCurrentPageTimesheet(currentPageTimesheet + 1);
    props.onChangeFilters({ ...filterNotiChange, offset: filterNotiChange.offset + 1 });
    setFilterNotiChange({ ...filterNotiChange, offset: filterNotiChange.offset + 1 });
  };
  const loadMoreWatchingList = () => {
    setCurrentPageWatchingList(currentPageWatchingList + 1);
    props.onChangeFiltersLineManager({
      ...filterNotiChangeLineManager,
      offset: filterNotiChangeLineManager.offset + 1,
    });
    setFilterNotiChangeLineManager({
      ...filterNotiChangeLineManager,
      offset: filterNotiChangeLineManager.offset + 1,
    });
  };
  const onChangeAllNotifi = (datanotifi: any) => {
    let obj: any = [];
    for (let i = 0; i < datanotifi.length; i++) {
      obj.push(datanotifi[i].id);
    }
    if (obj.length <= 0) return;
    dispatch(
      allNotifications({
        listNotify: obj,
        callBack: (response: any) => {
          dispatch(
            getNotifications({
              userId: getUser().id,
              limit: filterNotiChange.limit,
              offset: filterNotiChange.offset,
              titles: filterNotiChange.type,
            }),
          );
          dispatch(
            getNotificationsLineManager({
              userId: getUser().id,
              limit: filterNotiChangeLineManager.limit,
              offset: filterNotiChangeLineManager.offset,
              titles: filterNotiChangeLineManager.type,
            }),
          );
          props.onToggle(false);
        },
      }),
    );
  };
  const ViewMarkAllRead = () => {
    let unreadData: any = notifications.filter((i: any) => i?.status === UNREAD_STATUS);

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 2,
        }}
      >
        <div>{t('latest')}</div>
        {unreadData.length > 0 ? (
          <Button style={{ borderWidth: 0 }} onClick={() => onChangeAllNotifi(unreadData)}>
            {t('mark_all_read')}
          </Button>
        ) : null}
      </div>
    );
  };

  return (
    <div style={{ margin: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: 20, fontWeight: 500, fontFamily: 'Roboto' }}>
          {t('notifications')}
        </div>
      </div>
      <div>
        <Tabs defaultActiveKey="Timesheet" onChange={callback}>
          <TabPane
            tab={
              <>
                <div>{t('timesheet')}</div>
                {unreadNotiTotal !== 0 && (
                  <Badge className="-mr-2">{unreadNotiTotal > 99 ? '99+' : unreadNotiTotal}</Badge>
                )}
              </>
            }
            key="Timesheet"
          >
            <div
              id="scrollableDiv"
              style={{
                height: 400,
                overflow: 'auto',
              }}
            >
              <ViewMarkAllRead />
              <InfiniteScroll
                dataLength={currentDataTimesheet?.length}
                next={loadMoreTimesheet}
                hasMore={
                  isShowOnlyReaded
                    ? currentDataTimesheet.length < unreadNotiTotal
                    : currentDataTimesheet.length < totalNoti
                }
                loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
                endMessage={<Divider plain>{t('it_all_nothing_more')} 🤐</Divider>}
                scrollableTarget="scrollableDiv"
              >
                <List
                  dataSource={currentDataTimesheet}
                  renderItem={(propsItem: any) =>
                    RowNotifications({
                      ...propsItem,
                      ...props,
                      onItemClicked: onItemClicked,
                      markItemAsRead: markItemAsRead,
                    })
                  }
                />
              </InfiniteScroll>
            </div>
          </TabPane>
          <TabPane
            tab={
              <>
                <div>{t('request')}</div>
                {unreadNotiLineManager !== 0 && (
                  <Badge className="-mr-2">
                    {unreadNotiLineManager > 99 ? '99+' : unreadNotiLineManager}
                  </Badge>
                )}
              </>
            }
            key="WatchingList"
          >
            <div
              id="scrollableList"
              style={{
                height: 400,
                overflow: 'auto',
              }}
            >
              <ViewMarkAllRead />
              <InfiniteScroll
                dataLength={currentDataWatchingList?.length}
                next={loadMoreWatchingList}
                hasMore={
                  isShowOnlyReaded
                    ? currentDataWatchingList.length < unreadNotiLineManager
                    : currentDataWatchingList.length < totalNotiLineManager
                }
                loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
                endMessage={<Divider plain>{t('it_all_nothing_more')} 🤐</Divider>}
                scrollableTarget="scrollableList"
              >
                <List
                  dataSource={currentDataWatchingList}
                  renderItem={(propsItem: any) =>
                    RowNotifications({
                      ...propsItem,
                      ...props,
                      onItemClicked: onItemClicked,
                      markItemAsRead: markItemAsRead,
                    })
                  }
                />
              </InfiniteScroll>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

const Badge = styled.div`
  width: 20px;
  height: 15px;
  display: flex;
  border-radius: 35%;
  border: 1.5px solid white;
  background-color: #ff4c4c;
  position: absolute;
  justify-content: center;
  align-items: center;
  font-size: 8px;
  color: white;
  font-weight: bold;
  top: -2px;
  right: -10px;
  // transition: 1s;

  @media screen and (min-width: 1366px) {
    width: 22px;
    height: 17px;
    font-size: 10px;
    right: -12px;
    border: 2px solid white;
  }
`;
export default ListNotification;
